module.exports = __webpack_public_path__ + "img/notification-list.a763fbab.jpg";